import {Component, OnInit} from '@angular/core';

import {Message} from '../../services/message/message';
import {Subscription} from 'rxjs/Subscription';
import {Team} from '../../services/team/team';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {MessageService} from '../../services/message/message.service';
import {NewsService} from '../../services/news/news-service';
import {PlayerService} from '../../services/player/player.service';
import {Router} from '@angular/router';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import {TeamService} from '../../services/team/team.service';
import {MessageEntry} from '../../services/message/message-entry';
import {User} from '../../services/user/user';
import {isNullOrUndefined} from 'util';

import {ItemComponent} from '../item/item.component';
import {Tag} from '../../services/tag/tag';
import {Player} from '../../services/player/player';
import {HttpErrorResponse} from '@angular/common/http';
import {Query} from '../../services/query/query';
import {Massroster} from './massroster';
import {AngularQuery} from '../../services/query/angularquery';

import {MassrosterPreviewComponent} from './massroster-preview/massroster-preview.component';

@Component({
  selector: 'app-massroster',
  templateUrl: './massroster.component.html',
  styleUrls: ['./massroster.component.css']
})
export class MassrosterComponent implements OnInit {

  page: number = 0;
  public static NFL_DOT_COM_SOURCE_ID = 542;
  getPlayer = Massroster.getPlayer;
  isPreviewed = false;
  message: Message;
  msgSubscription: Subscription;
  noWeekChoice = 'Choose a week';
  playerFound: Subscription;
  playerList: Massroster;
  previewButtonDisabled = true;
  newsSubscription: Subscription;
  playerSubscription: Subscription;
  publishObject: Object;
  teamFound: Subscription;
  teamList: Team[] = [];
  teamListDest: Team[] = [];
  tForm: FormGroup;
  playersSelected: Player[] = []  
  userId = -1;
  weeks: String[] = [];
  originTeam = 0
  destinationTeam = 0
  itemPerPage=150

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    protected msgSvc: MessageService,
    private newsService: NewsService,
    private playerService: PlayerService,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    private teamService: TeamService,
  ) {
  }

  /**
   * Unsubscribe from all the subscriptions to avoid memory leaks.
   */
  ngOnDestroy() {

    if (this.msgSubscription) {
      this.msgSubscription.unsubscribe();
    }

    if (this.newsSubscription) {
      this.newsSubscription.unsubscribe();
    }

    if (this.playerFound) {
      this.playerFound.unsubscribe();
    }

    if (this.teamFound) {
      this.teamFound.unsubscribe();
    }

  }


  /**
   * Load the team information and initialize the Week information.
   */
  ngOnInit() {
    // Set up the message window with an initial message.
    this.msgSvc.sendMessageEntry(new MessageEntry({

      message: 'Loading...',
      level: 1

    }));


    let noChoiceTeam = new Team();
    noChoiceTeam.id = 0;
    noChoiceTeam.title = 'Select a team'
    this.teamList.push(noChoiceTeam);
    this.teamListDest.push(noChoiceTeam);

    // Prepare the user for a wait.
    this.spinnerService.show();

    // Set the author information from the session's User variable.
    let userString: string = sessionStorage.getItem('currentUser');
    if (null !== userString) {
      let user: User = new User(JSON.parse(userString));
      this.userId = user.id;
    }

    // Set up communications with the MessageService.
    this.msgSubscription = this.msgSvc.subject.subscribe(message => {
      this.message = message;
    });

    // Initialize the data structure for the page.
    this.tForm = this.fb.group({
      selectGroup: this.fb.group({
        teamSelect: [null, [Validators.required]],
        teamSelectOri: [null, [Validators.required]],
        showExtendedCheckbox: [false, [Validators.nullValidator]]
      }),
      playerGroup: this.fb.group({})
    })

    this.teamFound = this.teamService.getTeamsBySport('nfl').subscribe(
      (response) => {

        let specialObjects=[]
        // Pass back the array of Team objects after filtering out the invalid ones.
        for (let entry of response) {
          if((['Free Agent','NFL Draft Prospect','Retired'].indexOf(entry.title)>-1)) {
            specialObjects.push(new Team(entry));
          }
          if ('None' === entry.conference) {
            continue;
          }
          this.teamList.push(new Team(entry));
          this.teamListDest.push(new Team(entry));

        }

        this.teamList=this.teamList.concat(specialObjects);
        this.teamListDest=this.teamListDest.concat(specialObjects);
        // Notify the user.
        this.msgSvc.sendMessageEntry(new MessageEntry({

          message: 'Ready',
          level: 1

        }));

      },
      () => {

        // Notify the user.
        this.msgSvc.sendMessageEntry(new MessageEntry({

          message: 'Unable to load teams',
          level: 4

        }));

      },
      () => {

        // Hide the wait spinner.
        this.spinnerService.hide();

      }
    );

  }


  /**
   * If the week SELECT or team SELECT changes, check to see if the screen needs to
   * be updated.  If both SELECTs contain valid values, then the screen should
   * be drawn based on the new choices.
   */
  changed(): void {
    const teamSelectOrigin = this.tForm.controls['selectGroup'].value.teamSelectOri;
    this.isPreviewed = false;
    this.page = 0;
    this.teamListDest = this.teamList.filter((team) => team.id != teamSelectOrigin);
    if (isNullOrUndefined(teamSelectOrigin) || teamSelectOrigin == 0) {

      this.previewButtonDisabled = true;
      return;

    }
    
    //When team is changed, clear player group controls
    this.tForm.removeControl('playerGroup');
    this.tForm.addControl('playerGroup', this.fb.group({}))

    this.previewButtonDisabled = false;
    this.redraw(teamSelectOrigin);
  }

  changeTeam(): void {
    let values: Object = this.tForm.controls['selectGroup'].value;
    const teamSelect = this.tForm.controls['selectGroup'].value.teamSelect;
    if (isNullOrUndefined(teamSelect) || teamSelect == 0) {
      this.msgSvc.sendMessageEntry(new MessageEntry({
        message: 'You didn\'t select destiny team.',
        level: 4
      }));

      return;
    }

    let team: Team;
    // Get the Team object.
    for (let entry of this.teamList) {
      if (entry.id == values['teamSelect']) {
        team = entry;
        break;
      }
    }

    let articleBody: string = 'You have updated the players successfully. ';

    // If they didn't select any players, then exit now.
    if (this.playersSelected.length === 0) {
      this.msgSvc.sendMessageEntry(new MessageEntry({
        message: 'You didn\'t select any players',
        level: 4
      }));
      return;
    }

    // Turn on the spinner so they know to wait.
    this.spinnerService.show();

    // Create the query that will give us a URL.
    let query: AngularQuery = new AngularQuery();
    query.setEndpoint(AngularQuery.ENDPOINT_MASSROSTER_UPDATE);
    query.useParams(false);
    query.useCacheBuster(false);

    // Create the object that contains the preview data.
    let post: Object = {};
    post['article'] = articleBody;
    post['code'] = 'NFL';
    post['title'] = 'Thank you.';
    post['team'] = team.id;
    post['playerList'] = this.playersSelected;
    // Clear any existing preview subscriptions so we always start fresh.
    if (this.newsSubscription) {
      this.newsSubscription.unsubscribe();
    }

    this.newsSubscription = this.playerService.massRosterUpdate(query.getUrl(), JSON.stringify(post)).subscribe(
      (response) => {
        // Save the players and tags arrays plus the team object returned by the API.
        const modalRef = this.modalService.open(MassrosterPreviewComponent);
        modalRef.componentInstance.title = post['title'];
        modalRef.componentInstance.text = post['article'];
        modalRef.result.then((result) => {
          this.changed();
        }).catch((result) => {
          // Turn off the spinner.
          this.spinnerService.hide();
        });
      },
      (error) => {

        let msg: string = 'There was an error, please contact the admin team.';

        if (error instanceof HttpErrorResponse) {
          if (404 === error.status) {
            msg = Query.getQueryErrorMessage(error);
          } else {
            let body: any = error || '';
            if (!isNullOrUndefined(body.message)) {
              msg = 'Unable to continue: ' + body.message;
            }
          }
        }

        // Turn off the spinner.
        this.spinnerService.hide();
        this.msgSvc.sendMessageEntry(new MessageEntry({

          message: msg,
          level: 4

        }));

      },
      () => {
        // Turn off the spinner.
        this.spinnerService.hide();
        this.resetControls();
      }
    );

  }

  /**
   * Add or Remove player based on checkbox value.
   *
   * @param id  The Player ID number to add/remove.
   */
  changeSelection(id: number): void {
    const players = this.playerList.getPlayers()

    const currentPlayer = players.find(player => player.id === id)

    if(this.tForm.controls['playerGroup'].value[`player-${id}`]) {
      this.playersSelected.push(currentPlayer)
    } else {
      this.playersSelected = this.playersSelected.filter(player => player.id !== id)
    }
  }

  /**
   * Draw the list of players for the selected team.
   *
   * @param id  The Team ID number to retrieve players for.
   */
  redraw(id: number): void {
    // Prepare the user for a wait.
    this.spinnerService.show();

    // Notify the user.
    this.msgSvc.sendMessageEntry(new MessageEntry({
      message: 'Loading players ...',
      level: 1
    }));

    if (this.playerFound) {
      this.playerFound.unsubscribe();
    }

    if (this.tForm.controls['selectGroup'].value.showExtendedCheckbox) {
      this.itemPerPage = 1000;
    } else {
      this.itemPerPage = 150;
    }

    // Get the list of players.
    this.playerFound = this.playerService.getRosterTeam(id, this.page, this.itemPerPage).subscribe(
      (response) => {

        // Format the response into the specified number of columns and set the list.
        let players: Massroster = new Massroster(response, 5);
        this.playerList = players;
        // Dynamically add the controls to the page.
        for (let row of players.getRows()) {
          for (let player of row) {
            const playerGroup = this.tForm.controls['playerGroup'] as FormGroup;
            playerGroup.addControl('player-' + player.id, new FormControl(false, []))
          }
        }

        // Notify the user.
        this.msgSvc.sendMessageEntry(new MessageEntry({
          message: 'Ready',
          level: 1
        }));

      },
      () => {
        // Notify the user.
        this.msgSvc.sendMessageEntry(new MessageEntry({
          message: 'Unable to load players',
          level: 4
        }));

      },

      () => {
        // Prepare the user for a wait.
        this.spinnerService.hide();
      }
    );

  }
  nextPage() {
    this.page += 1;
    this.redraw(this.tForm.controls['selectGroup'].value.teamSelectOri);
  }
  prevPage() {
    this.page -= 1;
    this.redraw(this.tForm.controls['selectGroup'].value.teamSelectOri);
  }
  resetControls() {
    const selectGroup = this.tForm.controls['selectGroup'] as FormGroup;

    selectGroup.reset({
      teamSelect: 0,
      teamSelectOri: 0
    })

    this.tForm.removeControl('playerGroup');
    this.tForm.addControl('playerGroup', this.fb.group({}))

    this.changed();
    this.playersSelected = [];
    this.playerList.clearPlayers();
  }
}



// WEBPACK FOOTER //
// ./src/app/articles/massroster/massroster.component.ts